import { computed } from "mobx";
import { useCallback, useMemo } from "react";
import { usePipedriveStore } from "..";
import ILead from "../interfaces/ILead";

const useHasReminder = (): (lead: ILead) => boolean => {
    const pipedriveStore = usePipedriveStore();
    const activityIds = useMemo(() => computed(() => new Set(pipedriveStore.activities.map(a => a.id))), []).get();

    return useCallback((lead: ILead): boolean =>
        !!lead.activityId && activityIds.has(lead.activityId), [activityIds]);
};

export default useHasReminder;
